<template>
  <table-with-pagination
    :tableData="targetLists"
    :columnList="columnList"
    :pagination.sync="pagination"
    @size-change="getTargetList"
    @current-change="getTargetList"
    maxHeight="400px"
  />
</template>

<script>
import TableWithPagination, { TablePaginationMixin } from '@/components/common/TableWithPagination';
import { dateFormat } from '@/utils/dateFormat';
import { getLogLists } from '@/api/common';
export default {
  components: {
    TableWithPagination,
  },
  mixins: [TablePaginationMixin],
  name: '',
  props: {
    id: {
      type: String,
      default () {
        return '';
      },
      required: true,
    },
    module: {
      type: String,
      default () {
        return 'TENANT';
      },
    },
  },
  created () {
    this.handleSearch();
  },
  methods: {
    handleSearch () {
      if (!this.id) {
        return;
      }
      this.pagination.currentPage = 1;
      this.getTargetList();
    },
    getTargetList () {
      let param = {
        businessId: this.id,
        module: this.module,
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.currentPage,
        orderBy: [{
          orderByProperty: 'createTime',
          orderByType: 'DESC',
        }],
      };

      getLogLists(param).then(({body}) => {
        this.targetLists = body.list || [];
        this.pagination.total = +body.total;
      });
    },
  },
  data () {
    return {
      targetLists: [],
      columnList: [
        {
          tooltip: true,
          label: '事件类型',
          minWidth: '150px',
          prop: 'actionDesc',
        },
        {
          tooltip: true,
          label: '操作人',
          minWidth: '150px',
          prop: 'createUserName',
        },
        {
          tooltip: true,
          label: '时间',
          minWidth: '100px',
          prop: 'operateTime',
          format: v => {
            return v ? dateFormat(v).format('YYYY-MM-DD HH:mm:ss') : '--';
          },
        },
        {
          tooltip: true,
          label: '日志内容',
          minWidth: '150px',
          prop: 'content',
        },
      ],
    };
  },
};
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */

</style>
